import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

export abstract class BaseAdvertiserSectorComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
}
